import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const SESSION_TIMEOUT_EVENT = "session-timeout-event";
const IDLE_TIMEOUT_MS = Number(process.env.REACT_APP_IDLE_TIMEOUT_MS) || 15 * 60 * 1000;
const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

const SessionIdleWatcher = () => {
  const location = useLocation();
  const idleTimerRef = useRef(null);
  const isTimedOutRef = useRef(false);

  useEffect(() => {
    const hasToken = Boolean(localStorage.getItem("naturals_workspace_userId"));
    const isLoginPage =
      location.pathname === "/naturals/executive" ||
      location.pathname === "/naturals/workspace" ||
      location.pathname === "/naturals/partner" ||
      location.pathname === "/naturals/workspace" ||
      location.pathname === "/naturals/super-admin" ||
      location.pathname === "/naturals/franchise-admin";

    const clearIdleTimer = () => {
      if (idleTimerRef.current) {
        window.clearTimeout(idleTimerRef.current);
        idleTimerRef.current = null;
      }
    };

    if (!hasToken || isLoginPage) {
      isTimedOutRef.current = false;
      clearIdleTimer();
      return () => {
        clearIdleTimer();
      };
    }

    const startIdleTimer = () => {
      clearIdleTimer();
      idleTimerRef.current = window.setTimeout(() => {
        if (isTimedOutRef.current) return;

        isTimedOutRef.current = true;
        window.dispatchEvent(
          new CustomEvent(SESSION_TIMEOUT_EVENT, {
            detail: {
              message: "You were inactive for too long. Please log in again.",
            },
          })
        );
      }, IDLE_TIMEOUT_MS);
    };

    const handleActivity = () => {
      if (isTimedOutRef.current) return;
      startIdleTimer();
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, handleActivity, { passive: true });
    });

    startIdleTimer();

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, handleActivity);
      });
      clearIdleTimer();
    };
  }, [location.pathname]);

  return null;
};

export default SessionIdleWatcher;
